import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Configlist from "../../../Component/List/configlist";
import UserInfo from "./userinfo";
import useReactRouter from "use-react-router";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#f8f8f6",
    height: "100vh",
    paddingTop: "0.5rem",
  },
  leftContent: {
    height: `calc(100vh - 8.1rem)`,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: "#FFFFFF",
    overflowY: "auto",
    boxShadow: "1px 1px 2px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 2px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 2px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "flex",
    },
  },
  rightContent: {
    height: "calc(100vh - 8rem)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f8f6",
    overflowY: "auto",
  },
}));

const Userconfig = () => {
  const classes = useStyle();
  const [choice, setChoice] = useState(0);
  const { location } = useReactRouter();
  const [open, setopen] = useState(0);
  const [role] = useState(
    localStorage.getItem("role") === "admin" ? "Administrator" : "Contact User"
  );

  useEffect(() => {
    if (location.pathname === "app/user/main") {
      setChoice(0);
    } else {
      setChoice(1);
    }
  }, [location]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item lg={2} md={3} sm={3}>
          <div className={classes.leftContent}>
            <Configlist
              choice={choice}
              setChoice={setChoice}
              role={role}
              open={open}
              setopen={setopen}
            />
          </div>
        </Grid>
        <Grid item lg={10} md={12} sm={12}>
          <div className={classes.rightContent}>
            <UserInfo choice={choice} />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Userconfig;
